export default __webpack_public_path__ + "media/vendor/paper-dashboard-2-pro-html-v2.0.1/assets/img/bg/rawpixel-coms-6d3a3f1249330e2c3fc5f8203b7e4ce7.jpg";